import { isConstructorDeclaration } from "typescript";

export const CalculatePercentageOfTotal = (value?: number, total?: number) => {
    if(value==undefined || total==undefined || total==0)
    {
        return 0;
    }
    return parseInt(((value*100)/total).toString());
}

export const  numberWithCommas = (x: string) => {
    return x.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const GetNumberKMG = (total?: number) => {
    if (!total) return '';
    const digits = 1;
    const lookup = [
        { value: 1, symbol: "" },
        { value: 1e3, symbol: "K" },
        { value: 1e6, symbol: "M" },
        { value: 1e9, symbol: "G" },
        { value: 1e12, symbol: "T" },
        { value: 1e15, symbol: "P" },
        { value: 1e18, symbol: "E" }
      ];
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    var item = lookup.slice().reverse().find(function(item) {
       return total >= item.value;
    });
    return item ? (total / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : "0";
}